(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAnnounce(bar) {
      if (!bar || bar.dataset.shReady) return;
      bar.dataset.shReady = '1';
      var msgs = bar.querySelectorAll('.sh-announce__msg');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (msgs.length < 2 || reduce || bar.dataset.autorotate !== 'true') return;
      var speed = parseInt(bar.dataset.speed, 10) || 5000;
      var i = 0;
      var timer;
      // 29-ago (decisión del dueño en la auditoría): la banda enseña los
      // mensajes UNA VUELTA y se queda quieta en el último. Antes giraba
      // eternamente y en móvil no había forma de pararla (no hay hover ni foco
      // si los mensajes no son enlaces) — contenido que se mueve solo más de
      // 5 s sin mecanismo de pausa incumple WCAG 2.2.2. Y de paso se acaba el
      // setInterval perpetuo, que seguía disparando con la pestaña de fondo.
      var vueltasRestantes = msgs.length - 1;
      function rotate() {
        i = (i + 1) % msgs.length;
        msgs.forEach(function (m, idx) { m.classList.toggle('is-active', idx === i); });
        vueltasRestantes -= 1;
        if (vueltasRestantes <= 0) { clearInterval(timer); timer = null; }
      }
      function start() {
        clearInterval(timer);
        if (vueltasRestantes > 0) timer = setInterval(rotate, speed);
      }
      start();
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', function () { clearInterval(timer); });
      bar.addEventListener('focusout', start);
    }
    function boot() {
      document.querySelectorAll('.sh-announce').forEach(initAnnounce);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-decant"] && !Shopify.designMode) return;
  try {
    
  // ---- Vídeo diferido del decant ----
  // Monta el clip SOLO si su caja está realmente visible en este ancho (el otro
  // formato está en display:none y no debe descargarse: son 4-6 MB) y SOLO al
  // acercarse la sección. Ver el comentario largo del markup.
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // "Visible" se decide por CSS calculado, no por geometría: así funciona
    // igual antes del primer layout y no duplica los breakpoints de la hoja.
    function displayed(el) {
      for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
        if (getComputedStyle(n).display === 'none') return false;
      }
      return true;
    }

    function mount(box) {
      if (box.dataset.shLazyvideoDone) return;
      var tpl = box.querySelector('template[data-sh-lazyvideo-src]');
      if (!tpl) return;
      box.dataset.shLazyvideoDone = '1';
      var frag = tpl.content.cloneNode(true);
      var video = frag.querySelector('video');
      if (video && reduce) {
        // prefers-reduced-motion: se queda en el primer fotograma.
        video.removeAttribute('autoplay');
        video.autoplay = false;
      }
      tpl.replaceWith(frag);
      var v = box.querySelector('video');
      if (!v) return;
      var poster = box.querySelector('.sh-decant__poster');
      if (poster) {
        // Fuera el póster en cuanto hay imagen real, para no dejar dos capas.
        var drop = function () { if (poster.parentNode) poster.remove(); };
        v.addEventListener('loadeddata', drop, { once: true });
        v.addEventListener('playing', drop, { once: true });
      }
      // El clip sale del <template> con preload="none" para no pesar mientras
      // espera. Ya montado sí queremos que baje: se sube a "auto" y se pide play.
      // Los dos, a propósito — si la política de autoplay del navegador bloquea
      // el play(), el preload garantiza que el vídeo está cargado, y si además
      // no llega a reproducirse queda su propio poster, nunca un hueco.
      v.preload = 'auto';
      try { v.load(); } catch (e) {}
      if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }

    function boxes() { return document.querySelectorAll('[data-sh-lazyvideo]:not([data-sh-lazyvideo-done])'); }

    // Proximidad por geometría, para los repasos en los que el observer no ha
    // podido entregar nada (pestaña de fondo, cambio de formato al girar).
    function near(box) {
      var r = box.getBoundingClientRect();
      return r.top < window.innerHeight + 600 && r.bottom > -600;
    }

    function sweep() {
      boxes().forEach(function (box) {
        if (displayed(box) && (box.dataset.shLazyvideoNear || near(box))) mount(box);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var box = e.target;
          box.dataset.shLazyvideoNear = '1';
          io.unobserve(box);
          if (displayed(box)) mount(box);
        });
      }, { rootMargin: '600px 0px' });
      boxes().forEach(function (b) { io.observe(b); });
      // Al girar el móvil o redimensionar, el formato que toca cambia: si esa
      // caja ya se había cruzado, se monta ahora que sí se ve.
      window.addEventListener('resize', sweep, { passive: true });
      // En una pestaña de fondo el navegador NO entrega las observaciones del
      // IntersectionObserver (comprobado: 0 callbacks con document.hidden=true,
      // con la caja dentro del viewport). Al volver a la pestaña se repasa.
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) sweep();
      });
    } else {
      // Sin IntersectionObserver: se monta lo visible tras la carga, que sigue
      // dejando el vídeo fuera del camino crítico y no baja el que está oculto.
      window.addEventListener('load', function () {
        boxes().forEach(function (box) { if (displayed(box)) mount(box); });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(header) {
      if (!header || header.dataset.shReady) return;
      header.dataset.shReady = '1';

      function onScroll() {
        if (window.scrollY > 48) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
      }
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });

      var burger = header.querySelector('[data-sh-burger]');
      // El menú y su velo viven fuera del <header> (ver comentario en el markup):
      // se buscan en el wrapper de la sección
      var sectionRoot = header.parentElement || document;
      var mm = sectionRoot.querySelector('[data-sh-mm]');
      var mmVeil = sectionRoot.querySelector('[data-sh-mm-veil]');
      if (burger && mm) {
        var screens = mm.querySelectorAll('.sh-mm__screen');
        var showScreen = function (name) {
          screens.forEach(function (s) {
            s.classList.remove('is-active', 'is-prev');
            if (s.dataset.mmScreen === name) s.classList.add('is-active');
            else if (name !== 'root' && s.dataset.mmScreen === 'root') s.classList.add('is-prev');
          });
        };
        // Focus trap del menú: Tab circula dentro del panel, no escapa al fondo
        var mmUntrap = null;
        var trapMM = function () {
          var onKey = function (e) {
            if (e.key !== 'Tab') return;
            var els = mm.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
            var vis = Array.prototype.filter.call(els, function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
            if (!vis.length) return;
            var first = vis[0], last = vis[vis.length - 1];
            if (e.shiftKey && (document.activeElement === first || !mm.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && (document.activeElement === last || !mm.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
          };
          document.addEventListener('keydown', onKey, true);
          return function () { document.removeEventListener('keydown', onKey, true); };
        };
        var mmHeroesListos = false;
        var openMM = function () {
          // 29-ago (auditoría): las fotos de los submenús son `lazy` y viven en
          // un panel desplazado FUERA de la pantalla (translateX 105%), así que
          // el navegador no las descarga hasta que ya se ven → al entrar en
          // SHOP la tarjeta aparecía un instante en blanco. Al ABRIR el menú se
          // pasan a eager: se piden mientras el cliente lee la raíz, y siguen
          // costando cero en las cargas de página en que nadie abre el menú.
          if (!mmHeroesListos) {
            mmHeroesListos = true;
            mm.querySelectorAll('.sh-mm__hero img[loading="lazy"]').forEach(function (im) {
              im.setAttribute('loading', 'eager');
            });
          }
          showScreen('root');
          mm.classList.add('is-open');
          if (mmVeil) mmVeil.classList.add('is-open');
          // Solo se retira en modo píldora: arriba del todo el header no compite
          // con el panel y esconderlo haría desaparecer el logo
          if (header.classList.contains('is-scrolled')) header.classList.add('sh-header--behind');
          mm.setAttribute('aria-hidden', 'false');
          burger.setAttribute('aria-expanded', 'true');
          document.documentElement.style.overflow = 'hidden';
          var closeBtn0 = mm.querySelector('[data-sh-mm-close]');
          if (closeBtn0) setTimeout(function () { closeBtn0.focus(); }, 60);
          if (mmUntrap) mmUntrap();
          mmUntrap = trapMM();
        };
        var closeMM = function () {
          if (mmUntrap) { mmUntrap(); mmUntrap = null; }
          mm.classList.remove('is-open');
          if (mmVeil) mmVeil.classList.remove('is-open');
          header.classList.remove('sh-header--behind');
          mm.setAttribute('aria-hidden', 'true');
          burger.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
          var resBox = mm.querySelector('[data-mm-search-results]');
          if (resBox) { resBox.hidden = true; resBox.innerHTML = ''; }
          var resInput = mm.querySelector('.sh-mm__search-input');
          if (resInput) resInput.value = '';
          if (burger.focus) burger.focus({ preventScroll: true });
        };
        burger.addEventListener('click', openMM);
        var closeBtn = mm.querySelector('[data-sh-mm-close]');
        if (closeBtn) closeBtn.addEventListener('click', closeMM);
        if (mmVeil) mmVeil.addEventListener('click', closeMM);
        mm.querySelectorAll('[data-mm-go]').forEach(function (b) {
          b.addEventListener('click', function () { showScreen(b.dataset.mmGo); });
        });
        mm.querySelectorAll('[data-mm-back]').forEach(function (b) {
          b.addEventListener('click', function () { showScreen('root'); });
        });
        mm.querySelectorAll('a.sh-mm__item, a.sh-mm__quiz, .sh-mm__foot-link').forEach(function (a) {
          a.addEventListener('click', closeMM);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && mm.classList.contains('is-open')) closeMM();
        });
      }

      // Mega menús: apertura por hover/foco/clic, cierre con retardo y Esc
      var mega = header.querySelector('[data-sh-mega]');
      if (mega) {
        var triggers = header.querySelectorAll('[data-sh-menu]');
        var panels = mega.querySelectorAll('.sh-mega__panel');
        var veil = mega.querySelector('[data-feel-veil]');
        var closeTimer;
        var isDesktop = function () { return window.matchMedia('(min-width: 901px)').matches; };
        var showCard = function (panel, key) {
          var cards = panel.querySelectorAll('.sh-ed-card');
          if (!cards.length) return;
          var matched = false;
          cards.forEach(function (c) { var on = c.dataset.card === key; c.classList.toggle('is-active', on); if (on) matched = true; });
          // 29-ago (auditoría): el fallback repetía LA MISMA condición que
          // acababa de fallar (`dataset.card === 'default'`), así que cuando no
          // casaba nada apagaba TODAS las tarjetas y la columna editorial se
          // quedaba en blanco. Hoy no se ve porque cada panel tiene una tarjeta
          // con `trigger` vacío, pero el schema trae is_default en false: al
          // añadir un panel nuevo, o al rellenar ese trigger, explotaba.
          // Ahora cae a la tarjeta marcada por defecto y, si no la hay, a la 1ª.
          if (!matched) {
            var fb = panel.querySelector('.sh-ed-card[data-default="true"]') || cards[0];
            cards.forEach(function (c) { c.classList.toggle('is-active', c === fb); });
          }
        };
        var openPanel = function (idx) {
          clearTimeout(closeTimer);
          panels.forEach(function (p) {
            var on = p.dataset.shPanel === idx;
            p.classList.toggle('is-active', on);
            if (on) showCard(p, 'default');
          });
          if (veil) veil.style.opacity = '0';
          mega.classList.add('is-open');
          triggers.forEach(function (t) { t.setAttribute('aria-expanded', t.dataset.shMenu === idx ? 'true' : 'false'); });
        };
        var closeMega = function () {
          mega.classList.remove('is-open');
          triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        };
        var scheduleClose = function () { clearTimeout(closeTimer); closeTimer = setTimeout(closeMega, 180); };
        triggers.forEach(function (t) {
          t.addEventListener('mouseenter', function () { if (isDesktop()) openPanel(t.dataset.shMenu); });
          t.addEventListener('mouseleave', function () { if (isDesktop()) scheduleClose(); });
          t.addEventListener('focus', function () { if (isDesktop()) openPanel(t.dataset.shMenu); });
          // SIN handler de click: el nivel 1 es un <a href> y debe NAVEGAR.
          // Antes un e.preventDefault() lo cancelaba en escritorio y el clic solo
          // abría/cerraba el panel → /pages/gifting era INALCANZABLE desde el
          // menú que la nombra (lo vio el dueño). El panel sigue abriéndose con
          // hover y con focus (teclado), y cierra por mouseleave o Escape.
        });
        // Hover-swap de tarjetas editoriales + velo de color (Shop by Feeling)
        panels.forEach(function (panel) {
          // La tarjeta SE QUEDA en el último link recorrido (11-ago, lo vio el
          // dueño). Antes había un mouseleave que a los 240ms la devolvía a la
          // de por defecto, y eso hacía la tarjeta INALCANZABLE: es un enlace,
          // pero al soltar el link para ir hacia ella ya había cambiado. Ahora
          // solo cambia al entrar en otro link, y openPanel la resetea a
          // 'default' cada vez que el panel se abre de nuevo.
          panel.querySelectorAll('[data-swap]').forEach(function (link) {
            link.addEventListener('mouseenter', function () { showCard(panel, link.dataset.swap); });
          });
          panel.querySelectorAll('[data-feel-gradient]').forEach(function (fl) {
            fl.addEventListener('mouseenter', function () { if (veil) { veil.style.background = fl.dataset.feelGradient; veil.style.opacity = '0.92'; } });
            fl.addEventListener('mouseleave', function () { if (veil) veil.style.opacity = '0'; });
          });
        });
        mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        mega.addEventListener('mouseleave', scheduleClose);
        mega.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMega); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });
      }
    }
    // Abrir el cart drawer desde el ícono del header (fallback a /cart sin JS)
    function bindCartToggle() {
      var t = document.querySelector('[data-sh-cart-toggle]');
      if (!t || t.dataset.shBound) return;
      t.dataset.shBound = '1';
      t.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); }
      });
    }
    // Sincronizar el contador del carrito con los cambios (pubsub de Dawn)
    function setCartCount(n) {
      document.querySelectorAll('.sh-cart__count').forEach(function (el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
    }
    var cartCountBound = false;
    function bindCartCount() {
      if (cartCountBound) return;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        cartCountBound = true;
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
          var d = e && e.cartData;
          var n = d && typeof d.item_count === 'number' ? d.item_count : null;
          if (n === null) {
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) { setCartCount(c.item_count); })
              .catch(function () {});
          } else { setCartCount(n); }
        });
      } else {
        setTimeout(bindCartCount, 250);
      }
    }
    // Search overlay: ventana glass con búsqueda en vivo (predictive de Shopify)
    // Guard POR-ELEMENTO (no variable de módulo): al recargar la sección en el
    // theme editor, el DOM es nuevo y debe re-vincularse; un flag de módulo
    // sobrevive al shopify:section:load y dejaba la búsqueda muerta en el editor.
    function bindSearch() {
      var wrap = document.querySelector('[data-sh-search]');
      var toggle = document.querySelector('[data-sh-search-toggle]');
      if (!wrap || !toggle || wrap.dataset.shSearchBound) return;
      wrap.dataset.shSearchBound = '1';
      var input = wrap.querySelector('[data-sh-search-input]');
      var results = wrap.querySelector('[data-sh-search-results]');
      var suggest = wrap.querySelector('[data-sh-search-suggest]');
      var form = wrap.querySelector('.sh-search__bar');
      var searchUrl = (form && form.getAttribute('action')) || '/search';
      var viewAll = wrap.getAttribute('data-view-all') || 'See all results';
      var noResults = wrap.getAttribute('data-no-results') || 'No matches.';
      var moneyFmt = wrap.getAttribute('data-money') || '';
      var lastReq = 0;
      var debounce;

      function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
      // 24-oct · Cada perfume tiene ahora una variante «5 ml» (muestra de pago), así que
      // p.price (el MÍNIMO) pasó a ser el de la muestra y el buscador enseñaba $7.99 junto
      // a cada perfume. El precio que se enseña es el del FRASCO: el más bajo de las
      // variantes que no son «5 ml» si suggest.json las trae (no siempre las trae todas),
      // y si no, price_max, que en un perfume es el frasco. Lo que no tiene 5 ml, igual que antes.
      function precioFrasco(p) {
        var vs = (p.variants || []).filter(function (v) { return v.title !== '5 ml'; });
        var tiene5 = (p.variants || []).some(function (v) { return v.title === '5 ml'; });
        if (vs.length) {
          var min = vs.reduce(function (m, v) { var x = parseFloat(v.price); return (m === null || x < m) ? x : m; }, null);
          if (min !== null) return min.toFixed(2);
        }
        if ((tiene5 || p.type === 'Perfume') && p.price_max) return String(p.price_max);
        return (typeof p.price === 'string' && p.price) ? p.price : '';
      }
      // 25-oct · price_max falla si hay DOS frascos (Rey de Reyes: 100 ml y 200 ml salía
      // con el de 200). Si un perfume tiene varios precios y suggest.json no trae sus
      // variantes, se pregunta a su ficha (.js) y se corrige el número ya pintado.
      // Se guarda por handle: no se repite la petición en cada tecla.
      function corregirFrascos(cont, prods) {
        prods.forEach(function (p, i) {
          if (p.type !== 'Perfume' || p.price_min === p.price_max || (p.variants || []).length) return;
          var cache = window.__shFrasco || (window.__shFrasco = {});
          var pide = cache[p.handle] || (cache[p.handle] = fetch(p.url.split('?')[0] + '.js')
            .then(function (r) { return r.json(); })
            .then(function (j) {
              var c = j.variants.filter(function (v) { return v.title !== '5 ml'; }).map(function (v) { return v.price; });
              return c.length ? (Math.min.apply(null, c) / 100).toFixed(2) : '';
            }));
          pide.then(function (precio) {
            var el = precio && cont.querySelectorAll('.sh-search__result')[i];
            var span = el && el.getAttribute('data-h') === p.handle && el.querySelector('.sh-search__result-price');
            if (span) span.innerHTML = fmtPrice(precio);
          }).catch(function () {});
        });
      }
      function fmtPrice(v) {
        if (v === '' || v == null) return '';
        var amt = esc(v);
        if (moneyFmt && /\{\{\s*amount/.test(moneyFmt)) {
          return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/g, amt);
        }
        return amt;
      }
      function openSearch(e) {
        if (e) e.preventDefault();
        wrap.classList.add('is-open');
        wrap.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        setTimeout(function () { input.focus(); }, 80);
      }
      function closeSearch() {
        wrap.classList.remove('is-open');
        wrap.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        if (toggle && toggle.focus) toggle.focus({ preventScroll: true });
      }
      function showSuggest() { results.hidden = true; results.innerHTML = ''; suggest.hidden = false; }
      function render(products, q) {
        suggest.hidden = true;
        results.hidden = false;
        if (!products || !products.length) {
          results.innerHTML = '<p class="sh-search__empty">' + esc(noResults) + '</p>';
          // Sin resultados NO se esconden las sugerencias: el bloque que se
          // ocultaba arriba lleva las búsquedas populares y los accesos rápidos,
          // que son justo las salidas que el cliente necesita cuando su búsqueda
          // no ha encontrado nada.
          suggest.hidden = false;
          return;
        }
        var html = products.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
          var price = precioFrasco(p);
          return '<a class="sh-search__result" data-h="' + esc(p.handle) + '" href="' + p.url + '">' +
            (img
              ? '<img class="sh-search__result-img" src="' + img + '" alt="" width="46" height="46" loading="lazy">'
              : '<span class="sh-search__result-img"></span>') +
            '<span class="sh-search__result-info"><span class="sh-search__result-name">' + esc(p.title) + '</span>' +
            (price ? '<span class="sh-search__result-price">' + fmtPrice(price) + '</span>' : '') +
            '</span></a>';
        }).join('');
        html += '<a class="sh-search__viewall" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product">' + esc(viewAll) + ' ›</a>';
        results.innerHTML = html;
        corregirFrascos(results, products);
      }
      function fetchResults(q) {
        var reqId = ++lastReq;
        var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (reqId !== lastReq) return;
            var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            // Excluir add-ons ocultos (bolsa de regalo): solo se añaden desde el carrito.
            prods = prods.filter(function (p) { return !(p.type && String(p.type).toLowerCase() === 'add-on'); });
            render(prods, q);
          })
          .catch(function () {});
      }

      toggle.addEventListener('click', openSearch);
      var closeBtn = wrap.querySelector('[data-sh-search-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeSearch);
      var veil = wrap.querySelector('[data-sh-search-veil]');
      if (veil) veil.addEventListener('click', closeSearch);
      var panel = wrap.querySelector('.sh-search__panel');
      document.addEventListener('keydown', function (e) {
        if (!wrap.classList.contains('is-open')) return;
        if (e.key === 'Escape') { closeSearch(); return; }
        // Focus trap: mantener el foco dentro del panel (Tab/Shift+Tab ciclan)
        if (e.key === 'Tab' && panel) {
          var f = Array.prototype.slice.call(panel.querySelectorAll(
            'a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'
          )).filter(function (el) { return el.getClientRects().length > 0; });
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1], a = document.activeElement;
          if (!panel.contains(a)) { e.preventDefault(); first.focus(); return; }
          if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
        }
      });
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounce);
        if (q.length < 2) { showSuggest(); return; }
        debounce = setTimeout(function () { fetchResults(q); }, 220);
      });
      wrap.querySelectorAll('[data-sh-search-q]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          input.value = chip.getAttribute('data-sh-search-q');
          input.focus();
          fetchResults(input.value.trim());
        });
      });
    }
    // Búsqueda en vivo del menú móvil: mismo suggest.json y mismas tarjetas de
    // resultado que el overlay de la lupa, renderizadas bajo la barrita del panel
    function bindMMSearch() {
      var mm = document.querySelector('[data-sh-mm]');
      if (!mm) return;
      var form = mm.querySelector('.sh-mm__search');
      var box = mm.querySelector('[data-mm-search-results]');
      if (!form || !box || form.dataset.shLiveBound) return;
      form.dataset.shLiveBound = '1';
      var input = form.querySelector('input[name="q"]');
      var searchUrl = form.getAttribute('action') || '/search';
      var overlay = document.querySelector('[data-sh-search]');
      var viewAll = (overlay && overlay.getAttribute('data-view-all')) || 'See all results';
      var noResults = (overlay && overlay.getAttribute('data-no-results')) || 'No matches.';
      var moneyFmt = (overlay && overlay.getAttribute('data-money')) || '';
      var lastReq = 0;
      var debounce;
      function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
      // 24-oct · Cada perfume tiene ahora una variante «5 ml» (muestra de pago), así que
      // p.price (el MÍNIMO) pasó a ser el de la muestra y el buscador enseñaba $7.99 junto
      // a cada perfume. El precio que se enseña es el del FRASCO: el más bajo de las
      // variantes que no son «5 ml» si suggest.json las trae (no siempre las trae todas),
      // y si no, price_max, que en un perfume es el frasco. Lo que no tiene 5 ml, igual que antes.
      function precioFrasco(p) {
        var vs = (p.variants || []).filter(function (v) { return v.title !== '5 ml'; });
        var tiene5 = (p.variants || []).some(function (v) { return v.title === '5 ml'; });
        if (vs.length) {
          var min = vs.reduce(function (m, v) { var x = parseFloat(v.price); return (m === null || x < m) ? x : m; }, null);
          if (min !== null) return min.toFixed(2);
        }
        if ((tiene5 || p.type === 'Perfume') && p.price_max) return String(p.price_max);
        return (typeof p.price === 'string' && p.price) ? p.price : '';
      }
      // 25-oct · price_max falla si hay DOS frascos (Rey de Reyes: 100 ml y 200 ml salía
      // con el de 200). Si un perfume tiene varios precios y suggest.json no trae sus
      // variantes, se pregunta a su ficha (.js) y se corrige el número ya pintado.
      // Se guarda por handle: no se repite la petición en cada tecla.
      function corregirFrascos(cont, prods) {
        prods.forEach(function (p, i) {
          if (p.type !== 'Perfume' || p.price_min === p.price_max || (p.variants || []).length) return;
          var cache = window.__shFrasco || (window.__shFrasco = {});
          var pide = cache[p.handle] || (cache[p.handle] = fetch(p.url.split('?')[0] + '.js')
            .then(function (r) { return r.json(); })
            .then(function (j) {
              var c = j.variants.filter(function (v) { return v.title !== '5 ml'; }).map(function (v) { return v.price; });
              return c.length ? (Math.min.apply(null, c) / 100).toFixed(2) : '';
            }));
          pide.then(function (precio) {
            var el = precio && cont.querySelectorAll('.sh-search__result')[i];
            var span = el && el.getAttribute('data-h') === p.handle && el.querySelector('.sh-search__result-price');
            if (span) span.innerHTML = fmtPrice(precio);
          }).catch(function () {});
        });
      }
      function fmtPrice(v) {
        if (v === '' || v == null) return '';
        var amt = esc(v);
        if (moneyFmt && /\{\{\s*amount/.test(moneyFmt)) {
          return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/g, amt);
        }
        return amt;
      }
      function render(products, q) {
        box.hidden = false;
        if (!products || !products.length) {
          box.innerHTML = '<p class="sh-search__empty">' + esc(noResults) + '</p>';
          return;
        }
        var html = products.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
          var price = precioFrasco(p);
          return '<a class="sh-search__result" data-h="' + esc(p.handle) + '" href="' + p.url + '">' +
            (img
              ? '<img class="sh-search__result-img" src="' + img + '" alt="" width="46" height="46" loading="lazy">'
              : '<span class="sh-search__result-img"></span>') +
            '<span class="sh-search__result-info"><span class="sh-search__result-name">' + esc(p.title) + '</span>' +
            (price ? '<span class="sh-search__result-price">' + fmtPrice(price) + '</span>' : '') +
            '</span></a>';
        }).join('');
        html += '<a class="sh-search__viewall" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product">' + esc(viewAll) + ' ›</a>';
        box.innerHTML = html;
        corregirFrascos(box, products);
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounce);
        if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
        debounce = setTimeout(function () {
          var reqId = ++lastReq;
          var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (reqId !== lastReq) return;
              var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
              prods = prods.filter(function (p) { return !(p.type && String(p.type).toLowerCase() === 'add-on'); });
              render(prods, q);
            })
            .catch(function () {});
        }, 220);
      });
    }
    function boot() {
      document.querySelectorAll('[data-sh-header]').forEach(initHeader);
      bindCartToggle();
      bindCartCount();
      bindSearch();
      bindMMSearch();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-product-details"] && !Shopify.designMode) return;
  try {
    
  /* El precio del botón de comprar sigue al de la página. Dawn repinta el bloque
     de precio entero al cambiar de variante, así que no vale con leerlo una vez:
     se observa y se copia. Mismo mecanismo que la barra pegajosa.
     3-nov: se observaba `.price__container`, pero Dawn reemplaza ese nodo al
     cambiar de variante y el observador se quedaba mirando uno desconectado: al
     elegir la muestra de 5 ml el botón seguía con el precio del frasco. Ahora se
     observa un ancestro estable (product-info) y el destino se busca en cada
     pasada, por si también lo repintan. */
  (function () {
    if (!document.querySelector('[data-sh-atc-price]')) return;
    var host = document.querySelector('product-info') ||
               document.querySelector('.product__info-container');
    if (!host) return;
    function leer() {
      var onSale = document.querySelector('.product__info-container .price--on-sale');
      var el = (onSale && document.querySelector('.product__info-container .price__sale .price-item--sale')) ||
               document.querySelector('.product__info-container .price__regular .price-item--regular') ||
               document.querySelector('.product__info-container .price-item--regular');
      return el ? el.textContent.trim() : '';
    }
    function sync() {
      var out = document.querySelector('[data-sh-atc-price]');
      var t = leer();
      // Solo si cambia: el botón vive dentro de host y escribirlo siempre
      // volvería a disparar el observador sin fin.
      if (out && t && out.textContent !== t) out.textContent = t;
    }
    sync();
    new MutationObserver(sync).observe(host, { childList: true, subtree: true, characterData: true });
  })();

  (function () {
    function initMeters(m) {
      if (m.dataset.shReady) return;
      m.dataset.shReady = '1';
      m.classList.add('reveal');
      // Entrada escalonada: la segunda barra arranca un pelo después que la
      // primera, para que se lean como dos gestos y no como uno solo.
      m.querySelectorAll('.sh-meter-bar i').forEach(function (b, i) {
        b.style.transitionDelay = (i * 140) + 'ms';
      });
      if (!('IntersectionObserver' in window)) { m.classList.add('in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { m.classList.add('in'); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(m);
      setTimeout(function () { m.classList.add('in'); }, 3000);
    }
    function boot() {
      /* 17-ago: aquí se llamaba a initPyramid, que iluminaba el nivel al pasar el
         ratón por sus burbujas. Con la pirámide en imagen ya no existe ningún
         `.sh-scent-tier` que encender, así que el bloque se retiró entero en vez
         de dejarlo corriendo en vacío. */
      document.querySelectorAll('[data-sh-meters]').forEach(initMeters);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();

  (function () {
    /* 7-sep · Deslizador él/ella de la historia (perfumes unisex). Dos fotos
       apiladas; la de arriba (él) se recorta con clip-path hasta --x. En
       escritorio sigue al ratón sin pulsar; en móvil se arrastra (touch-action
       pan-y deja pasar el scroll vertical); con el foco, flechas ← →. */
    function initCmp(el) {
      if (el.dataset.shReady) return;
      el.dataset.shReady = '1';
      var dragging = false, touched = false;
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      function setX(clientX) {
        var r = el.getBoundingClientRect();
        var f = (clientX - r.left) / r.width;
        f = Math.max(0.02, Math.min(0.98, f));
        el.style.setProperty('--x', (f * 100) + '%');
        el.style.setProperty('--x-frac', f);
        el.setAttribute('aria-valuenow', Math.round(f * 100));
        if (!touched) { touched = true; el.classList.add('is-touched'); }
      }
      el.addEventListener('pointermove', function (e) { if (dragging || (fine && e.pointerType === 'mouse')) setX(e.clientX); });
      el.addEventListener('pointerdown', function (e) {
        dragging = true; el.classList.add('is-active');
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
        setX(e.clientX);
      });
      function up() { dragging = false; el.classList.remove('is-active'); }
      el.addEventListener('pointerup', up);
      el.addEventListener('pointercancel', up);
      el.addEventListener('lostpointercapture', up);
      el.addEventListener('keydown', function (e) {
        var v = parseFloat(el.style.getPropertyValue('--x-frac')) || 0.5;
        if (e.key === 'ArrowLeft') { v -= 0.05; } else if (e.key === 'ArrowRight') { v += 0.05; } else { return; }
        e.preventDefault();
        var r = el.getBoundingClientRect();
        setX(r.left + Math.max(0.02, Math.min(0.98, v)) * r.width);
      });
    }
    function boot() { document.querySelectorAll('[data-sh-cmp]').forEach(initCmp); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sh-quiz]');
    if (!root) return;
    var STEPS = ['intro', 'q1', 'q2', 'q3', 'q4', 'email', 'result'];
    var idx = 0;
    var answers = {}; // una respuesta POR PREGUNTA (volver atrás sobrescribe)
    var labels = {};  // texto visible de cada respuesta, para la línea «por qué»
    var fill = root.querySelector('[data-quiz-fill]');
    var stepEls = root.querySelectorAll('.sh-quiz__step');

    var DATA = [];
    try { DATA = JSON.parse(root.querySelector('[data-quiz-data]').textContent); } catch (e) { DATA = []; }

    // Raíces de palabras (sin tildes, en minúsculas) en ES y EN: los metacampos
    // llegan traducidos según el idioma de la tienda.
    var KW = {
      feel: {
        soft: ['floral', 'almizcl', 'musk', 'polv', 'powder', 'limpi', 'clean', 'suave', 'soft', 'iris', 'blanc', 'white', 'delicad', 'delicate', 'luminos', 'luminous', 'radiant'],
        sweet: ['gourmand', 'vainill', 'vanill', 'caramel', 'dulce', 'sweet', 'golos', 'frutal', 'fruity', 'prali', 'tonka', 'miel', 'honey', 'cremos', 'creamy', 'adictiv', 'addictive'],
        deep: ['ambar', 'amber', 'oud', 'amader', 'woody', 'wood', 'especi', 'spic', 'cuero', 'leather', 'incienso', 'incense', 'oriental', 'intens', 'calid', 'warm', 'oscur', 'dark', 'profund', 'deep', 'magnet'],
        fresh: ['citric', 'citrus', 'acuatic', 'aquatic', 'aromat', 'fresc', 'fresh', 'verde', 'green', 'marin', 'ozon', 'liger', 'light', 'elegan', 'chipre', 'chypre']
      },
      note: {
        vanilla: ['vainill', 'vanill', 'caramel', 'prali', 'tonka', 'miel', 'honey', 'chocolat', 'cacao', 'cocoa', 'cafe', 'coffee', 'azucar', 'sugar', 'malvavisc', 'marshmallow', 'almendra', 'almond', 'toffee', 'crema', 'cream'],
        flowers: ['rosa', 'rose', 'jazmin', 'jasmin', 'nardo', 'tuberos', 'azahar', 'orange blossom', 'neroli', 'peoni', 'peony', 'gardenia', 'lirio', 'lily', 'iris', 'ylang', 'magnoli', 'violet', 'orquide', 'orchid', 'heliotrop', 'fresia', 'freesia', 'flor', 'flower'],
        citrus: ['bergamot', 'limon', 'lemon', 'naranj', 'orange', 'mandarin', 'pomelo', 'grapefruit', 'manzana', 'apple', 'pera', 'pear', 'frambues', 'raspberr', 'fresa', 'strawberr', 'lichi', 'lychee', 'pina', 'pineapple', 'cereza', 'cherr', 'melocot', 'peach', 'grosella', 'currant', 'ciruel', 'plum', 'frutos', 'berr', 'mango', 'coco', 'lima', 'lime', 'pomeloc', 'yuzu', 'fruta', 'fruit'],
        woods: ['oud', 'ambar', 'amber', 'sandal', 'cedro', 'cedar', 'vetiver', 'pachul', 'patchouli', 'incienso', 'incense', 'cuero', 'leather', 'azafran', 'saffron', 'madera', 'wood', 'musgo', 'moss', 'tabaco', 'tobacco', 'benjui', 'benzoin', 'labdan', 'ladano', 'guayaco', 'guaiac', 'cachemir', 'cashmere', 'agar']
      },
      when: {
        day: ['diari', 'daily', 'everyday', 'oficina', 'office', 'dia', 'day', 'todo el ano', 'year', 'trabajo', 'work', 'casual', 'firma', 'signature'],
        night: ['noche', 'night', 'cena', 'dinner', 'cita', 'date', 'fiesta', 'party', 'pareja', 'couple', 'evening', 'ocasion', 'occasion', 'gala', 'romant', 'salir', 'going out'],
        warm: ['verano', 'summer', 'primavera', 'spring', 'calor', 'heat', 'hot', 'playa', 'beach', 'vacacion', 'vacation'],
        cold: ['invierno', 'winter', 'otono', 'fall', 'autumn', 'frio', 'cold']
      }
    };

    function norm(s) {
      return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }
    function hits(text, list) {
      var n = 0;
      for (var i = 0; i < list.length; i++) if (text.indexOf(list[i]) !== -1) n++;
      return n;
    }
    function hasTag(p, tag) { return (',' + p.g + ',').indexOf(',' + tag + ',') !== -1; }
    function isUnisex(p) { return hasTag(p, 'unisex') || (hasTag(p, 'women') && hasTag(p, 'men')); }

    function rank() {
      var pool = DATA.filter(function (p) {
        if (answers.who === 'her') return hasTag(p, 'women') || hasTag(p, 'unisex');
        if (answers.who === 'him') return hasTag(p, 'men') || hasTag(p, 'unisex');
        return true;
      });
      if (!pool.length) pool = DATA.slice();
      pool.forEach(function (p) {
        var fam = norm(p.f), notes = norm(p.n), occ = norm(p.o);
        var s = 0;
        if (answers.feel) {
          s += 3 * Math.min(2, hits(fam, KW.feel[answers.feel]));
          s += 0.5 * Math.min(2, hits(notes, KW.feel[answers.feel]));
        }
        if (answers.note) s += 1.5 * Math.min(3, hits(notes, KW.note[answers.note]));
        if (answers.when && hits(occ, KW.when[answers.when])) s += 2;
        if (answers.who === 'any' && isUnisex(p)) s += 1;
        // Azar suave: mueve el orden entre perfumes casi empatados, no entre
        // uno que encaja mucho y otro que no.
        p._s = s + Math.random() * 1.2;
      });
      pool.sort(function (a, b) { return b._s - a._s; });
      return pool;
    }

    function fillCard(p) {
      var frag = root.querySelector('[data-quiz-card]').content.cloneNode(true);
      function f(k) { return frag.querySelector('[data-f="' + k + '"]'); }
      var stage = f('stage');
      stage.href = p.u;
      stage.classList.add('sh-stage--' + p.s);
      if (p.i) f('img').src = p.i; else f('img').remove();
      f('brand').textContent = p.v || '';
      if (!p.v) f('brand').remove();
      f('name').textContent = p.t;
      var why = [labels.feel, labels.when].filter(Boolean).join(' · ');
      if (why) f('why').textContent = why; else f('why').remove();
      if (p.l) f('blurb').textContent = p.l; else f('blurb').remove();
      f('price').textContent = p.p;
      f('view').href = p.u;
      if (!p.m && p.id) {
        f('variant').value = p.id;
        f('choose').remove();
      } else {
        f('form').remove();
        f('choose').href = p.u;
      }
      return frag;
    }

    function renderResult() {
      var ranked = rank();
      var box = root.querySelector('[data-quiz-result]');
      box.textContent = '';
      var altsWrap = root.querySelector('[data-quiz-alts]');
      var grid = root.querySelector('[data-quiz-alts-grid]');
      grid.textContent = '';
      if (!ranked.length) { altsWrap.hidden = true; return; }
      box.appendChild(fillCard(ranked[0]));
      // La pareja de alternativas, compactas (solo foto + nombre + precio)
      var alts = ranked.slice(1, 3);
      alts.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'sh-quiz__alt';
        a.href = p.u;
        var st = document.createElement('span');
        st.className = 'sh-quiz__alt-stage sh-stage--' + p.s;
        if (p.i) {
          var im = document.createElement('img');
          im.src = p.i; im.alt = ''; im.width = 480; im.height = 480; im.loading = 'lazy';
          st.appendChild(im);
        }
        var nm = document.createElement('span');
        nm.className = 'sh-quiz__alt-name';
        nm.textContent = p.t;
        var pr = document.createElement('span');
        pr.className = 'sh-quiz__alt-price';
        pr.textContent = p.p;
        a.appendChild(st); a.appendChild(nm); a.appendChild(pr);
        grid.appendChild(a);
      });
      altsWrap.hidden = alts.length === 0;
    }

    function jumpTop() { window.scrollTo({ top: 0, behavior: 'instant' }); }
    function show(i) {
      idx = i;
      stepEls.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-step') === STEPS[i]); });
      if (fill) fill.style.width = (i / (STEPS.length - 1)) * 100 + '%';
      jumpTop();
      // Gestión de foco: el teclado/lector aterriza en el título del paso nuevo
      var active = root.querySelector('.sh-quiz__step.is-active');
      var head = active && (active.querySelector('h1, h2') || active);
      if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
    }

    // Alta de email por la API cliente de Klaviyo — misma lista (T8dEYJ) y
    // mecanismo que el popup, así que dispara el mismo welcome flow del 10%.
    // custom_source "Scent Quiz" para poder segmentar. Fire-and-forget: el
    // resultado no se bloquea por la red.
    var emailForm = root.querySelector('[data-quiz-email-form]');
    var emailErr = root.querySelector('[data-quiz-email-err]');
    var thanks = root.querySelector('[data-quiz-thanks]');
    function finish(subscribed) {
      if (thanks) thanks.hidden = !subscribed;
      renderResult();
      show(6);
    }
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = emailForm.querySelector('input[type="email"]');
      var val = (inp.value || '').trim();
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
      emailErr.hidden = ok;
      inp.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (!ok) { inp.focus(); return; }
      // 25-sep: el «gracias» (código en camino) solo sale si Klaviyo responde ok.
      // Si falla, el resultado sale igual, sin prometer un código que no llegará.
      if (emailForm.dataset.sending) return;
      emailForm.dataset.sending = '1';
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VJW7X9', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Scent Quiz',
                profile: { data: { type: 'profile', attributes: { email: val } } }
              },
              relationships: { list: { data: { type: 'list', id: 'T8dEYJ' } } }
            }
          })
        })
          .then(function (r) { finish(r.ok); })
          .catch(function () { finish(false); })
          .then(function () { delete emailForm.dataset.sending; });
      } catch (err) { delete emailForm.dataset.sending; finish(false); /* la promesa del resultado no depende del alta */ }
    });
    root.querySelector('[data-quiz-skip]').addEventListener('click', function () { finish(false); });

    root.querySelector('[data-quiz-start]').addEventListener('click', function () { answers = {}; labels = {}; show(1); });
    root.querySelectorAll('.sh-quiz__opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var q = opt.getAttribute('data-q');
        answers[q] = opt.getAttribute('data-v');
        labels[q] = opt.textContent.trim();
        show(idx < 4 ? idx + 1 : 5);
      });
    });
    root.querySelectorAll('[data-quiz-back]').forEach(function (b) {
      b.addEventListener('click', function () { show(idx > 1 ? idx - 1 : 0); });
    });
    root.querySelector('[data-quiz-retake]').addEventListener('click', function () {
      answers = {};
      labels = {};
      if (thanks) thanks.hidden = true;
      var inp = emailForm.querySelector('input[type="email"]');
      if (inp) { inp.value = ''; inp.setAttribute('aria-invalid', 'false'); }
      emailErr.hidden = true;
      show(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-sh-satc]');
    if (!bar) return;
    var priceOut = bar.querySelector('[data-sh-satc-price]');
    var addBtn = bar.querySelector('[data-sh-satc-add]');

    function mainAddButton() {
      return document.querySelector('.product-form__submit') ||
             document.querySelector('product-form button[name="add"]');
    }
    function priceEl() {
      var onSale = document.querySelector('.price--on-sale');
      return (onSale && document.querySelector('.price__sale .price-item--sale')) ||
             document.querySelector('.price__regular .price-item--regular') ||
             document.querySelector('.price-item--regular');
    }
    function syncPrice() {
      var el = priceEl();
      if (el && el.textContent.trim()) priceOut.textContent = el.textContent.trim();
    }
    // Espejar el estado del botón real de Dawn: si la variante está agotada,
    // el botón del sticky se deshabilita y muestra "Sold out" (antes quedaba
    // activo y su clic era un no-op silencioso al estar disabled el de Dawn).
    function syncState() {
      var main = mainAddButton();
      if (!main) return;
      var soldOut = main.disabled || main.getAttribute('aria-disabled') === 'true';
      addBtn.disabled = soldOut;
      if (soldOut) addBtn.setAttribute('aria-disabled', 'true');
      else addBtn.removeAttribute('aria-disabled');
      var txt = (main.querySelector('span') || main).textContent.trim();
      if (txt) addBtn.textContent = txt;
    }

    bar.removeAttribute('hidden');

    addBtn.addEventListener('click', function () {
      var main = mainAddButton();
      if (main && !main.disabled) main.click();
    });

    // Mostrar siempre que el botón de compra de Dawn no esté a la vista
    // (también al aterrizar con el botón bajo el fold: nunca hay un
    // primer viewport sin botón de compra visible).
    var trigger = mainAddButton();
    if (trigger && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(trigger);
    } else {
      bar.classList.add('is-visible');
    }

    // Espejar el precio al cambiar de variante. Dawn REEMPLAZA el nodo .price
    // al cambiar la variante, asi que observamos un ancestro estable (product-info).
    var host = document.querySelector('product-info') || document.querySelector('.product') || document.querySelector('main');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () { syncPrice(); syncState(); }).observe(host, { childList: true, subtree: true, characterData: true });
    }
    syncPrice();
    syncState();
  })();

  } catch(e) { console.error(e); }
})();
})();
